<template>
    <div class="panel-content">
        <h2>Lift-uitleg</h2>
        <p>Door gebruik te maken van het scroll-wheel, te scrollen op uw mousepad of door te swipen kunt u veranderen van verdieping binnen het FIELD-LAB gebouw. Hier vindt u per verdieping een aangesloten partner, met informatie en beeld over hun rol in deze samenwerking.</p>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
